<template>
  <div>
    <el-card class="mtf-head">
      <div class="custom-flex-space-between">
        <div class="curMonth">
          <el-radio-group v-model="timeDimension" @change="changeTimeDimension" class="custom-elRadioGroup"
            text-color="#78bfcf" fill="#ffffff">
            <el-radio-button label="Month">{{ $t('DomesticWarehousing.CurrentMonth') }}</el-radio-button>
            <el-radio-button label="Season">{{ $t('DomesticWarehousing.CurrentQuarter') }}</el-radio-button>
            <el-radio-button label="Year">{{ $t('DomesticWarehousing.CurrentYear') }}</el-radio-button>
          </el-radio-group>
        </div>
        <div class='curDateStr' style="float:left;">
          <div style="float:left; line-height: 30px;">{{$t('DomesticWarehousing.Date')}}：</div>
          <div style="float:left;">
            <el-date-picker class='datebox' format='yyyy-MM' value-format='yyyy-MM' type='month'
              :placeholder="$t('DomesticWarehousing.PleaseSelectDate')" v-model="dateStr"
              @change="changeDate"></el-date-picker>
          </div>
        </div>
      </div>
      <el-divider />
    </el-card>
    <div style="">
      <el-card class="mtf-head">
        <el-row :gutter="20">
          <el-col v-loading="inboundStaticsLoading" :span="6">
            <div class="accumulatedL custom-flex-space-between borderRadius"
              style="background: #62befc;margin-top: 2px;padding: 5px 20px 5px 5px;">
              <div style="margin-top:10px;">
                <p class="ocean-label">{{$t('DomesticWarehousing.InboundOperations')}}</p>
                <div class="ocean-content">{{ inboundStaticsData.inQty + ' ' + $t('DomesticWarehousing.Order') }}</div>
                <div class="ocean-content">{{ inboundStaticsData.outQty + ' ' + $t('DomesticWarehousing.CubicMeter') }}
                </div>
              </div>
              <img src="@/assets/wms/inStore.png" style="width: 100px;height: 70px;">
            </div>
          </el-col>
          <el-col v-loading="outboundTEULoading" :span="6">
            <div class="accumulatedL custom-flex-space-between borderRadius"
              style="background: #f6d5d9;padding: 5px 20px 5px 5px;">
              <div style="margin-top:10px;">
                <p class="ocean-label">{{ $t('DomesticWarehousing.OutboundOperations') }}</p>
                <div class="ocean-content">{{ outboundTEUData.teuQty + ' TEU' }}</div>
              </div>
              <img src="@/assets/wms/outStore.png" style="width: 70px;height: 70px;">
            </div>
          </el-col>
          <el-col v-loading="currentStockLoading" :span="6">
            <div class="accumulatedL custom-flex-space-between borderRadius"
              style="background: #affcfc;padding-right:20px;padding: 5px 20px 5px 5px;">
              <div style="margin-top:10px;">
                <p class="ocean-label">{{ $t('DomesticWarehousing.CFSRealTimeStock')}}</p>
                <div class="ocean-content">{{ currentStockData.currentQty + ' ' + $t('DomesticWarehousing.CubicMeter')
                  }}</div>
              </div>
              <img src="@/assets/wms/inventory.png" style="width: 80px;height: 70px;">
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-card v-loading="inboundChartLoading" class="mt10">
            <BarChart v-if="showMileageEchart" id="InboundChart" ref="InboundChart" />
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card v-loading="outboundContainerChartLoading" class="mt10 minheight280">
            <BarChart v-if="showMileageEchart" id="outboundContainerChart" ref="outboundContainerChart" />
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card v-loading="outboundTEUChartLoading" class="mt10 minheight280">
            <BarChart v-if="showMileageEchart" id="outboundTEUChart" ref="outboundTEUChart" />
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card v-loading="stockCubeChartLoading" class="mt10 minheight280">
            <BarChart v-if="showMileageEchart" id="stockCubeChart" ref="stockCubeChart" />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import BarChart from '@/components/wms/barChart'
import { getCFSInboundStatisticApi, getCFSOutboundStatisticApi, getCFSCurrentCubeStockStatisticApi, getCFSInboundBarDataApi, getCFSOutboundContainerBarDataApi, getCFSOutboundTEUBarDataApi, getCFSStockCubeBarDataApi, } from '@/api/wms'
export default {
  components: {
    BarChart
  },
  props: {
    jobType: {
      type: String,
      default: 'DC'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inboundStaticsData: {},
      outboundTEUData: {},
      currentStockData: {},
      /** 周期 */
      timeDimension: 'Month',
      showMileageEchart: true,
      inboundStaticsLoading: true,
      outboundTEULoading: true,
      currentStockLoading: true,
      inboundChartLoading: true,
      outboundContainerChartLoading: true,
      outboundTEUChartLoading: true,
      stockCubeChartLoading: true,
      dateStr: '',
      lang: 'zh',
    }
  },
  computed: {},
  // watch: {
  //   timeDimension(newValue, oldValue) {
  //     if (newValue !== oldValue) {
  //       this.dateStr = ''
  //       this.init()
  //     }
  //   }
  // },
  mounted() {    
    this.lang = this.$ls.get('lang');
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    this.dateStr = `${year}-${month}`;
    this.init()
  },
  methods: {
    handleChange() {
      this.$emit('update:jobType', this.circuitSelect)
    },
    changeDate(val) {      
      this.init()
    },
    changeTimeDimension(){      
      this.init()
    },
    init() {
      this.getCFSInboundStatistic()
      this.getCFSOutboundStatistic()
      this.getCFSCurrentCubeStockStatistic()
      this.getCFSInboundBarData()
      this.getCFSOutboundContainerBarData()
      this.getCFSOutboundTEUBarData()
      this.getCFSStockCubeBarData()
    },
    async getCFSInboundStatistic() {
      this.inboundStaticsLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr }
      console.log(params)
      var res = await getCFSInboundStatisticApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.inboundStaticsData = data
        console.log(this.inboundStaticsData)
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.inboundStaticsLoading = false
    },
    async getCFSOutboundStatistic() {
      this.outboundTEULoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getCFSOutboundStatisticApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.outboundTEUData = data
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.outboundTEULoading = false
    },
    async getCFSCurrentCubeStockStatistic() {
      this.currentStockLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getCFSCurrentCubeStockStatisticApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.currentStockData = data
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.currentStockLoading = false
    },
    async getCFSInboundBarData() {
      this.inboundChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getCFSInboundBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.InboundChart.chartInit(data);
        console.log(data)
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.inboundChartLoading = false
    },
    async getCFSOutboundContainerBarData() {
      this.outboundContainerChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getCFSOutboundContainerBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.outboundContainerChart.chartInit(data);
        console.log(data)
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.outboundContainerChartLoading = false
    },
    async getCFSOutboundTEUBarData() {
      this.outboundTEUChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getCFSOutboundTEUBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.outboundTEUChart.chartInit(data);
        console.log(data)
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.outboundTEUChartLoading = false
    },
    async getCFSStockCubeBarData() {
      this.stockCubeChartLoading = true
      let duration = this.timeDimension
      const dateStr = this.dateStr

      const lang = this.$ls.get('lang');
      const params = { Duration: duration, CustomerCode: this.customerCode, DateStr: dateStr, Lang: lang }
      var res = await getCFSStockCubeBarDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        // this.currentTonneStockData = data
        this.$refs.stockCubeChart.chartInit(data);
        console.log(data)
      } else {
        this.messagebox.alert('查询失败，Query failure')
      }
      this.stockCubeChartLoading = false
    },
  }
}
</script>
<style scoped>
/* 公共样式提取至内部 开始*/
.custom-input {
  border: none;
  width: 200px;
}
.custom-input >>> input {
  border: none;
  background: #f6f6f8;
}
/* 公共样式提取至内部 结束 */

.mtf1 {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head {
  margin-top: -1px;
  border-top: #fff;
}
.mtf-head >>> .el-card__body {
  padding: 0px 20px 0px 20px !important;
  margin-bottom: 20px;
}

.mt10 {
  margin-top: 10px;
}
.mt16 {
  margin-top: 16px;
}
.fw600 {
  font-weight: 600;
}
.minheight350 {
  min-height: 350px;
}
.minheight280 {
  min-height: 280px;
}
.border {
  border: 1px solid #e5e7eb;
}
.borderRadius {
  border-radius: 10px;
}
.dian::before {
  content: '';
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #58c6e4;
  border-radius: 50%;
  margin-right: 6px;
  margin-bottom: 2px;
}
.curMonth {
  padding: 4px 4px;
  background: #f6f6f8;
}

.curDateStr {
  padding: 4px 4px;
  margin-top: 10px;
}

.elSelect {
  width: 180px;
  margin-left: 10px;
  border-radius: 8px;
}

.accumulatedL,
.accumulatedR {
  padding-left: 24px;
}
.ocean-label{
  font-size: 15px;
  font-weight: 400;
  color: #4b5563;
}
.ocean-content{
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 5px 0 0 0px;
}

>>>.el-input__inner,
>>> .el-input__prefix,
>>> .el-input__icon {
  line-height: 30px;
  height: 30px;
}
</style>
